import React from 'react';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Antes armaba el repertorio del acto la noche anterior, buscando partituras en 10 pestañas. Ahora abro el tomo que necesito y ya está resuelto.',
  author: 'Marcela G.',
  role: 'Docente de Música, Nivel Primario, CABA'
}, {
  text: 'Lo que más cambió fue la tranquilidad antes de un acto escolar. Ya sé exactamente qué van a tocar los chicos.',
  author: 'Fernando L.',
  role: 'Profesor de Música, Córdoba'
}, {
  text: 'El planificador anual me salvó el año. Ya no llego a marzo sin saber qué voy a dar en cada trimestre.',
  author: 'Romina T.',
  role: 'Docente suplente, Rosario'
}];
export function Reviews() {
  return <section className="bg-white text-navy py-12" data-id="element-257">
      <div className="max-w-md mx-auto px-4" data-id="element-258">
        <h2 className="text-2xl font-bold text-center mb-8" data-id="element-259">
          Lo que dicen las/los docentes que ya lo usan
        </h2>

        <div className="flex flex-col gap-4" data-id="element-260">
          {reviews.map((review, idx) => <div key={idx} className="bg-gray-50 border border-gray-100 p-6 rounded-2xl shadow-sm" data-id="element-261">
              <div className="flex gap-1 mb-3" data-id="element-262">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-263" />)}
              </div>
              <p className="text-[15px] italic text-gray-700 mb-4 leading-relaxed" data-id="element-264">
                "{review.text}"
              </p>
              <div className="text-sm" data-id="element-265">
                <span className="font-bold block" data-id="element-266">{review.author}</span>
                <span className="text-gray-500" data-id="element-267">{review.role}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}